import React from 'react';

function Icon(props) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g
        id="Errors"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Maintenance-mode"
          transform="translate(-464.000000, -368.000000)"
          stroke="#1274C4"
          strokeWidth="3"
        >
          <g
            id="wench-double-copy-4"
            transform="translate(466.000000, 370.000000)"
          >
            <path
              d="M21.5342927,39.8012277 L39.7990447,21.5280073 C44.1288014,23.5943272 49.2907001,22.7078113 52.6830446,19.3152807 C56.0753892,15.9227501 56.9618564,10.7605683 54.8956499,6.43057406 L51.3492169,9.987157 C49.8757692,11.4606855 47.4868385,11.4606855 46.0133908,9.987157 C44.5399431,8.51362847 44.5399431,6.12456669 46.0133908,4.65103816 L49.557335,1.10441066 C45.2275783,-0.961909181 40.0656796,-0.0753932887 36.6733351,3.31713731 C33.2809906,6.7096679 32.3945233,11.8718497 34.4607298,16.2018439 L16.2009553,34.4700866 C11.8711986,32.4037667 6.70929989,33.2902826 3.31695537,36.6828132 C-0.0753891536,40.0753438 -0.961856423,45.2375256 1.10435009,49.5675198 L4.65078306,46.0233812 C6.13684665,44.6406887 8.45045864,44.6815826 9.88673556,46.1159285 C11.3230125,47.5502744 11.3671437,49.8639537 9.98660923,51.3520335 L6.44266498,54.8986609 C10.7719771,56.961419 15.9311244,56.0732635 19.3215421,52.6815416 C22.7119597,49.2898197 23.5983651,44.1300968 21.5342927,39.8012277 Z"
              id="Path"
            />
            <path
              d="M18.5566823,24 L17.159608,22.6149083 C12.5736483,24.7846073 7.10630663,23.8537385 3.51322825,20.2914775 C-0.079850126,16.7292166 -1.01877197,11.3087677 1.16969736,6.76214121 L4.925982,10.4835953 C6.48661745,12.0308453 9.01690742,12.0308453 10.5775428,10.4835952 C12.1381783,8.93634518 12.1381783,6.42775721 10.5775429,4.88050714 L6.82389424,1.15643971 C11.409383,-1.00951934 16.8738105,-0.0769288897 20.464848,3.4844829 C24.0558855,7.04589469 24.9947418,12.4637617 22.8085329,17.0092068 L24,18.1930682"
              id="Path"
            />
            <path
              d="M37.542593,32 L39.1712468,33.6260686 C43.6687845,31.4797952 49.0307102,32.4006136 52.5545104,35.9244138 C56.0783105,39.448214 56.999129,44.8101397 54.8528556,49.3076774 L51.168996,45.6264029 C49.6384511,44.0958582 47.1569478,44.0958582 45.626403,45.626403 C44.0958582,47.1569478 44.0958582,49.6384511 45.6264029,51.168996 L49.3076774,54.8528556 C44.8101397,56.999129 39.448214,56.0783105 35.9244138,52.5545104 C32.4006136,49.0307102 31.4797952,43.6687845 33.6260686,39.1712468 L32,37.542593"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export { Icon };
